const Theme = {
  body_background_color: 'rgb(228,1,59)',

  title_font: 'NexaRegular',
  text_font: 'NexaLight',
  button_font: 'NexaRegular',

  logo_image_url: 'larocheposay.png', 
  logo_height: 200,
  token_url: 'larocheposay.png',
  token_width: 65,
  number_hidden: true,

  card_header_margin_top: 0,
  header_no_border: true,
  button_border_width: 2,
  button_color: 'rgb(239,126,110)',
  button_radius: 100,
  title_margin: '10px',

  footer_img_top_width: 491,
  footer_border_hidden: true,
}

export default Theme
//https://app.clickup.com/t/86dwr1hty